import { Injectable, ɵfindLocaleData } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/* eslint-disable @typescript-eslint/no-explicit-any */

@Injectable()
export class TranslationGenerator {
  constructor(private translate: TranslateService) {}

  init() {
    this.translate.onLangChange.subscribe(({ lang }) => {
      const localeData = ɵfindLocaleData(lang);

      this.setShortDatePlaceholders(localeData, lang);
    });
  }

  private setShortDatePlaceholders(localeData: any, lang: string) {
    /* CUSTOMIZATION: Site-wide date placeholders are MM-dd-yyyy (US; not locale short date). */
    void localeData;
    const shortDate = 'MM-dd-yyyy';

    // keep-localization-pattern: ^common\.date_format\.letters\.\w$
    const localizedShortDate = shortDate.replace(/(\w)/g, (_, letter) =>
      this.translate.instant(`common.date_format.letters.${letter}`)
    );
    this.translate.set('placeholder-short-date', localizedShortDate, lang);
    this.translate.set('placeholder-short-date-caps', localizedShortDate.toUpperCase(), lang);
  }
}
